import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { PriceType } from '../../_kernel/PriceType'

export type AffiliateType = (typeof AFFILIATES)[number]
export const AFFILIATES = [
  'stayforlong',
  'email',
  'email_price_watch',
  'criteo',
  'findhotel',
  'vio',
  'gha',
  'hotelscan',
  'kayak',
  'neredekal',
  'skyscanner',
  'tripadvisor',
  'trivago',
  'idealo',
  'ebooking',
  'vipdistrict',
  'cozycozy',
  'bha',
] as const

export const AFFILIATES_METAS = [
  'findhotel',
  'vio',
  'gha',
  'bha',
  'neredekal',
  'trivago',
  'hotelscan',
  'kayak',
  'skyscanner',
  'tripadvisor',
  'cozycozy',
]

export const NO_CUG_AFFILIATES = ['vipdistrict'] as const

export const AffiliateValidation = z.object({
  value: z.enum(AFFILIATES, { required_error: 'value is required' }),
  priceType: z.instanceof(PriceType).optional(),
})

export class Affiliate extends Model {
  static create({ value, priceType }: z.infer<typeof AffiliateValidation>) {
    AffiliateValidation.parse({ value, priceType })
    return new Affiliate(value, priceType)
  }

  static default() {
    return new Affiliate('stayforlong')
  }

  constructor(
    private readonly _value: AffiliateType,
    private readonly _priceType?: PriceType
  ) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  get capitalizedValue() {
    return this._value.charAt(0).toUpperCase() + this._value.slice(1)
  }

  get priceType() { return this._priceType } // prettier-ignore

  get isMeta() {
    return AFFILIATES_METAS.includes(this.value)
  }

  isDefault() {
    return this.isType('stayforlong')
  }

  isType(type: AffiliateType) {
    return this.value === type
  }

  isOneOfType(types: AffiliateType[]) {
    return types.includes(this.value)
  }

  isCug() {
    return !NO_CUG_AFFILIATES.includes(this.value as any)
  }

  toJSON() {
    return {
      value: this.value,
      priceType: this.priceType?.value,
    }
  }
}
